var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentPenWriteStreamlineUltimate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M22.588 4.591a2.25 2.25 0 1 0-3.182-3.182L8.14 12.675l3.182 3.182L22.588 4.591Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.14 12.675 6.747 17.25l4.575-1.393m6.959-13.323 3.182 3.182M3.747 18.75H3a2.25 2.25 0 1 0 0 4.5h15.75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentPenWriteStreamlineUltimate);
export default __webpack_public_path__ + "static/media/Content-Pen-Write--Streamline-Ultimate.5b4fdba02a17993a9dbd9d6c523ee97d.svg";
export { ForwardRef as ReactComponent };